var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg5682",
    viewBox: "0 0 26.895001 35.884998",
    height: "35.884998mm",
    width: "26.895mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5676"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath82",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path80",
    clipRule: "evenodd",
    d: "M 0,746.504 H 602.504 V -8.504 H 0 v 755.008"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath88",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    clipRule: "evenodd",
    d: "M -603,-9 H 603 V 747 H -603 V -9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath94",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M 0,738 H 594 V 0.18 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.253974,-83.357481)",
    id: "g6001"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,-0.35277777,88.583135,83.978327)",
    id: "g96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#ffdd2e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.779,-0.23 1.531,-0.517 2.277,-0.821 2.992,-1.204 5.769,-2.794 8.33,-4.76 2.757,-2.114 5.142,-4.582 7.17,-7.404 1.142,-1.581 2.139,-3.241 3,-4.983 1.364,-2.763 2.349,-5.649 2.96,-8.66 0.233,-1.154 0.414,-2.314 0.518,-3.488 0.074,-0.738 0.123,-1.474 0.149,-2.214 0.036,-0.637 0.037,-1.268 0.027,-1.899 -0.027,-1.148 -0.093,-2.283 -0.227,-3.423 -0.275,-2.496 -0.824,-4.924 -1.621,-7.304 -0.911,-2.69 -2.122,-5.238 -3.65,-7.645 -1.62,-2.567 -3.55,-4.88 -5.768,-6.946 -1.937,-1.807 -4.048,-3.371 -6.333,-4.696 -2.013,-1.171 -4.115,-2.134 -6.317,-2.894 -0.096,-0.024 -0.186,-0.068 -0.287,-0.079 -0.09,0.062 -0.199,0.067 -0.301,0.093 -3.895,0.97 -7.7,2.194 -11.362,3.851 -2.393,1.085 -4.694,2.333 -6.852,3.858 -1.546,1.094 -2.996,2.307 -4.25,3.74 -0.569,0.645 -1.065,1.327 -1.402,2.132 -0.573,1.377 -0.861,2.79 -0.729,4.285 0.094,0.99 0.351,1.937 0.767,2.84 0.194,0.409 0.389,0.834 0.699,1.156 1.05,1.11 2.067,2.236 3.169,3.293 1.442,1.375 2.795,2.835 4.149,4.298 0.18,0.197 0.345,0.396 0.483,0.621 0.582,0.984 0.918,2.038 0.913,3.184 0,0.986 -0.249,1.919 -0.659,2.811 -0.671,1.457 -1.668,2.675 -2.816,3.775 -0.633,0.601 -1.351,1.114 -2.003,1.693 -1.081,0.976 -2.113,1.991 -2.988,3.169 -0.648,0.891 -1.213,1.82 -1.436,2.924 -0.235,1.119 -0.352,2.24 -0.203,3.379 0.187,1.452 0.732,2.776 1.555,3.983 0.913,1.326 2.069,2.406 3.376,3.321 0.628,0.441 1.308,0.796 1.973,1.171 2.87,1.634 5.808,3.135 8.835,4.451 2.719,1.183 5.495,2.207 8.34,3.023 C -0.34,-0.118 -0.154,-0.093 0,0 Z m 9.171,-33.655 c 0,1.627 0,3.255 0,4.886 0,0.568 0.011,1.138 0,1.704 -0.027,1.291 -1.266,2.228 -2.517,1.899 -0.903,-0.232 -1.514,-1.028 -1.514,-1.981 0,-4.347 0,-8.685 0,-13.032 0,-0.124 0.012,-0.242 0.033,-0.369 0.229,-1.326 1.68,-2.07 2.876,-1.451 0.737,0.373 1.118,0.998 1.122,1.83 0.008,2.17 0,4.34 0,6.514"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,-0.35277777,88.583135,83.978327)",
    id: "g100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#4b5252",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.154,-0.093 -0.34,-0.118 -0.514,-0.165 -2.845,-0.816 -5.621,-1.84 -8.34,-3.023 -3.027,-1.316 -5.965,-2.817 -8.835,-4.451 -0.665,-0.375 -1.345,-0.73 -1.973,-1.171 -1.307,-0.915 -2.463,-1.995 -3.376,-3.321 -0.823,-1.207 -1.368,-2.531 -1.555,-3.983 -0.149,-1.139 -0.032,-2.26 0.203,-3.379 0.223,-1.104 0.788,-2.033 1.436,-2.924 0.875,-1.178 1.907,-2.193 2.988,-3.169 0.652,-0.579 1.37,-1.092 2.003,-1.693 1.148,-1.1 2.145,-2.318 2.816,-3.775 0.41,-0.892 0.659,-1.825 0.659,-2.811 0.005,-1.146 -0.331,-2.2 -0.913,-3.184 -0.138,-0.225 -0.303,-0.424 -0.483,-0.621 -1.354,-1.463 -2.707,-2.923 -4.149,-4.298 -1.102,-1.057 -2.119,-2.183 -3.169,-3.293 -0.31,-0.322 -0.505,-0.747 -0.699,-1.156 -0.416,-0.903 -0.673,-1.85 -0.767,-2.84 -0.132,-1.495 0.156,-2.908 0.729,-4.285 0.337,-0.805 0.833,-1.487 1.402,-2.132 1.254,-1.433 2.704,-2.646 4.25,-3.74 2.158,-1.525 4.459,-2.773 6.852,-3.858 3.662,-1.657 7.467,-2.881 11.362,-3.851 0.102,-0.026 0.211,-0.031 0.301,-0.093 -0.513,-0.198 -1.043,-0.346 -1.57,-0.495 -1.625,-0.463 -3.276,-0.801 -4.953,-1.021 -1.083,-0.15 -2.171,-0.245 -3.269,-0.278 -0.394,-0.013 -0.787,-0.029 -1.182,-0.029 -4.343,-0.022 -8.542,0.72 -12.609,2.239 -3.7,1.386 -7.078,3.33 -10.125,5.846 -4.407,3.653 -7.747,8.106 -10.015,13.368 -1.004,2.348 -1.748,4.785 -2.231,7.295 -0.25,1.298 -0.424,2.612 -0.527,3.935 -0.109,1.42 -0.126,2.848 -0.063,4.266 0.126,3.033 0.648,6.001 1.54,8.896 1.441,4.641 3.73,8.818 6.889,12.518 3.331,3.904 7.331,6.944 11.988,9.12 2.652,1.239 5.416,2.124 8.291,2.676 1.299,0.25 2.614,0.421 3.937,0.523 1.428,0.109 2.861,0.129 4.291,0.068 2.468,-0.099 4.894,-0.468 7.276,-1.09 0.637,-0.157 1.255,-0.343 1.877,-0.54 z m -24.263,-33.669 c 0.001,4.727 -3.787,8.63 -8.589,8.668 -4.837,0.031 -8.717,-3.848 -8.729,-8.632 -0.012,-4.842 3.892,-8.643 8.57,-8.687 4.841,-0.048 8.749,3.871 8.748,8.651"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,-0.35277777,91.818459,95.851062)",
    id: "g104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106",
    style: {
      fill: "#4b5252",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,-2.174 0.008,-4.344 0,-6.515 -0.004,-0.831 -0.385,-1.456 -1.122,-1.829 -1.196,-0.62 -2.647,0.125 -2.876,1.451 -0.021,0.127 -0.033,0.245 -0.033,0.369 0,4.347 0,8.684 0,13.032 0,0.953 0.611,1.749 1.514,1.981 C -1.266,8.818 -0.027,7.881 0,6.59 0.011,6.024 0,5.454 0,4.886 0,3.255 0,1.627 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,-0.35277777,80.023687,95.856354)",
    id: "g108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path110",
    style: {
      fill: "#ffdd2e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.001,-4.78 -3.907,-8.699 -8.748,-8.651 -4.678,0.044 -8.582,3.845 -8.57,8.687 0.012,4.784 3.892,8.663 8.729,8.632 C -3.787,8.63 0.001,4.727 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,-0.35277777,71.258218,112.13987)",
    id: "g112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path114",
    style: {
      fill: "#4b5252",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 3.103 l 3.668,-9.775 c 0.23,-0.642 0.433,-1.205 0.6,-1.696 0.162,-0.482 0.304,-0.934 0.425,-1.353 0.309,1.02 0.633,2.019 0.965,2.997 0.047,0.121 0.077,0.204 0.098,0.25 l 3.883,10.341 4.097,-10.539 c 0.198,-0.508 0.379,-1.025 0.554,-1.534 0.168,-0.511 0.329,-1.025 0.478,-1.547 0.091,0.394 0.211,0.832 0.364,1.31 0.15,0.476 0.34,1.038 0.578,1.694 L 22.446,0 h 3.134 l -7.495,-20.118 -4.421,11.045 c -0.192,0.492 -0.368,0.967 -0.525,1.42 -0.159,0.455 -0.301,0.886 -0.426,1.288 -0.151,-0.522 -0.3,-1.005 -0.442,-1.46 -0.156,-0.452 -0.309,-0.888 -0.468,-1.304 L 7.464,-20.118"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "#4b5252",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    d: "m 81.058385,118.97071 h 1.109168 v -6.83084 h -1.109168 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,-0.35277777,90.764359,115.56993)",
    id: "g118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path120",
    style: {
      fill: "#4b5252",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,-1.376 -0.259,-2.678 -0.768,-3.902 -1.29,-5.123 -2.042,-6.219 -3.025,-7.176 -4.022,-8.139 -5.148,-8.878 -6.4,-9.384 c -1.25,-0.514 -2.564,-0.771 -3.938,-0.771 -1.393,0 -2.724,0.258 -3.987,0.772 -1.267,0.517 -2.382,1.252 -3.351,2.207 -0.993,0.957 -1.742,2.049 -2.251,3.263 -0.509,1.214 -0.765,2.522 -0.765,3.913 0,1.386 0.256,2.686 0.765,3.916 0.509,1.225 1.258,2.319 2.251,3.292 0.983,0.959 2.103,1.69 3.353,2.193 1.255,0.502 2.581,0.752 3.985,0.752 1.394,0 2.712,-0.25 3.961,-0.752 C -5.135,8.898 -4.012,8.167 -3.025,7.208 -2.042,6.226 -1.29,5.124 -0.768,3.895 -0.259,2.663 0,1.365 0,0 Z m -3.282,0 c 0,0.977 -0.175,1.907 -0.529,2.792 -0.363,0.882 -0.874,1.667 -1.544,2.352 -0.651,0.679 -1.406,1.202 -2.271,1.57 -0.858,0.362 -1.761,0.546 -2.712,0.546 -0.957,0 -1.86,-0.182 -2.72,-0.541 -0.858,-0.363 -1.621,-0.887 -2.292,-1.575 -0.669,-0.68 -1.184,-1.463 -1.536,-2.338 -0.352,-0.884 -0.528,-1.819 -0.528,-2.806 0,-0.978 0.176,-1.907 0.528,-2.775 0.352,-0.876 0.867,-1.655 1.536,-2.341 0.671,-0.689 1.429,-1.212 2.288,-1.576 0.854,-0.359 1.761,-0.538 2.724,-0.538 0.941,0 1.84,0.179 2.689,0.538 0.848,0.364 1.612,0.887 2.294,1.576 0.67,0.686 1.181,1.472 1.544,2.344 0.354,0.88 0.529,1.8 0.529,2.772"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,-0.35277777,92.038946,118.97071)",
    id: "g122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path124",
    style: {
      fill: "#4b5252",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 V 20.127 L 12.298,8.293 C 12.631,7.958 12.97,7.601 13.315,7.22 13.656,6.843 14.019,6.413 14.397,5.938 v 13.425 h 2.907 V -0.755 L 4.757,11.292 C 4.422,11.617 4.096,11.964 3.784,12.324 3.477,12.686 3.173,13.069 2.893,13.461 V 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,-0.35277777,89.250943,115.56605)",
    id: "g126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    style: {
      fill: "#ffdd2e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-3.333 -2.708,-6.036 -6.036,-6.036 -3.336,0 -6.041,2.703 -6.041,6.036 0,3.336 2.705,6.034 6.041,6.034 C -2.708,6.034 0,3.336 0,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWion);
export default __webpack_public_path__ + "static/media/wion.bee6186b5a4ea143cff3038ca54e5628.svg";
export { ForwardRef as ReactComponent };